import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test": "suporting-text-error",
  class: "input-text__error-label"
}
const _hoisted_2 = {
  key: 1,
  "data-test": "suporting-text",
  class: "input-text__supporting-label"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InputHelperText',
  props: {
    error: { default: '' },
    supportingText: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.error), 1))
      : (_ctx.supportingText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.supportingText), 1))
        : _createCommentVNode("", true)
  ]))
}
}

})